import { Stack, useToast } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
// ...existing code...
import Wrapper from './Wrapper';
import ZaraButton from 'components/custom-components/buttons/Button';
import { useChangeTrainingGuideMutation } from 'graphql/generated';
import { useError } from 'error-provider/ErrorProvider';
import { z } from 'zod';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useApolloClient } from '@apollo/client';
import { useGetAgent } from './hooks/useGetAgent';
import { useEffect } from 'react';
import Loader from './Loader';

const schema = z.object({
    newGuide: z.string().min(1, 'Required'),
});

type Schema = z.infer<typeof schema>;

const TrainingGuide = () => {
    const { control, handleSubmit, setValue } = useForm<Schema>({
        defaultValues: {
            newGuide: '',
        },
        mode: 'onSubmit',
        resolver: zodResolver(schema),
    });
    const apolloClient = useApolloClient();
    const { showError } = useError();
    const toast = useToast();
    // ...existing code...
    const params = useParams();

    const [changeGuide, { loading: isChangeGuideLoading }] = useChangeTrainingGuideMutation({
        onError(error) {
            showError(undefined, error);
        },
    });

    const { data, loading } = useGetAgent();



    const onSubmit = (form: Schema) => {
        changeGuide({
            variables: {
                newGuide: form.newGuide,
                agentId: params.id as string,
            },
            onCompleted(data) {
                if (data.changeTrainingGuide.__typename === 'SuccessType') {
                    toast({
                        title: data.changeTrainingGuide.message,
                        status: 'success',
                        isClosable: true,
                    });
                    apolloClient.cache.modify({
                        id: `AgentType:${params.id as string}`,
                        fields: {
                            trainingGuide() {
                                return form.newGuide;
                            },
                        },
                    });
                }
                if (data.changeTrainingGuide.__typename === 'ErrorType') {
                    toast({
                        title: data.changeTrainingGuide.message,
                        status: 'error',
                        isClosable: true,
                    });
                }
            },
        });
    };

    useEffect(() => {
        if (data?.trainingGuide) setValue('newGuide', data.trainingGuide);
    }, [data, setValue]);

    if (loading || !data) {
        return <Loader />;
    }

    return (
        <Wrapper title='Current Training Guide' description={`Update the AI agent's instructions`}>
            <Stack as='form' onSubmit={handleSubmit(onSubmit)} alignItems='self-start'>
                <Controller
                    control={control}
                    name='newGuide'
                    render={({ field: { onChange, onBlur, value } }) => (
                        <textarea
                            required
                            placeholder='Enter training guide here...'
                            className='flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 min-h-[200px] lg:min-h-[300px]'
                            autoFocus={true}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                        />
                    )}
                />

                <ZaraButton type='submit' variant='primary' w='auto' fontSize='sm' isLoading={isChangeGuideLoading}>
                    Update Training Guide
                </ZaraButton>
            </Stack>
        </Wrapper>
    );
};

export default TrainingGuide;
